import { render, staticRenderFns } from "./MiniPost.vue?vue&type=template&id=7a59e3f4&scoped=true&"
import script from "./MiniPost.vue?vue&type=script&lang=js&"
export * from "./MiniPost.vue?vue&type=script&lang=js&"
import style0 from "./MiniPost.vue?vue&type=style&index=0&id=7a59e3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a59e3f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VAvatar,VCard,VCol,VImg,VRow})
